<div class="rich-switch-group-container"
     [attr.data-size]="size"
     [attr.data-checked]="checked"
     [attr.data-disabled]="disabled">
  
  <umss-switch
    [checked]="checked"
    [disabled]="disabled"
    [size]="size"
    [ariaLabel]="computedAriaLabel"
    (checkedChange)="onSwitchChange($event)">
  </umss-switch>
  
  <div class="rich-switch-group-content">
    <umss-label 
      [text]="label"
      [required]="required"
      size="Regular"
      weight="Medium">
    </umss-label>
    
    <p class="rich-switch-group-secondary">
      {{ secondaryText }}
    </p>
  </div>
</div>